<template>
  <div>

    <div v-for="(event, idx) in events" :key="event.id || idx"
      class="custom-list-event-row-mobile justify-center d-flex d-md-none"
      :style="{ backgroundColor: event.eventColor }"
      :class="{ 'custom-list-event-row--last': idx === events.length - 1 }" @click="$emit('event-click', event)">

      <v-row class="d-flex flex-row px-2 py-4">
        <v-col cols="12">
          <div class="d-flex flex-row align-center">
            <div class="custom-list-event-indicator-mobile rounded-circle"
              :style="{ backgroundColor: event.backgroundColor }">
            </div>
            <span class="text-subtitle-2 ml-2 font-weight-regular">
              {{ formatEventTime(event) }} - {{ event.title
              }}</span>
          </div>
        </v-col>
      </v-row>

    </div>

    <CalendarListEventRow v-for="(event, idx) in events" :key="event.id || idx" :event="event"
      :is-last="idx === events.length - 1" :thumbnail-src="academyThumbnailSrc" :title="event.title"
      :background-color="event.backgroundColor" :date-text="formatEventDate(event.start)"
      :time-text="formatEventTime(event)" :instructor-line="'Instructor: ' + getProfessorName(event)"
      :pricing-label="String(event.vacation ? $t('message.vacation') : 'Free class')"
      :participants-text="getParticipantsText(event)" :membership-label="String(
        event.allowNonMembers
          ? $t('message.visitors_allowed') || 'Visitors allowed'
          : $t('message.members_only') || 'Members only'
      )
        " @event-click="$emit('event-click', $event)" />
  </div>
</template>

<script>
import CalendarListEventRow from './CalendarListEventRow.vue';

export default {
  name: 'CalendarListEvents',
  components: { CalendarListEventRow },
  props: {
    events: {
      type: Array,
      default: () => []
    }
  },
  emits: ['event-click'],
  computed: {
    academyThumbnailSrc() {
      const img = this.$store.state.academyImage;
      return img ? this.userFile(img) : null;
    }
  },
  methods: {
    formatEventDate(d) {
      if (!d) return '';
      const date = d instanceof Date ? d : new Date(d);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear()).slice(-2);
      return `${month}/${day}/${year}`;
    },
    formatEventTime(event) {
      const start = event.start instanceof Date ? event.start : new Date(event.start);
      const end = event.end ? (event.end instanceof Date ? event.end : new Date(event.end)) : null;
      const startStr = start.toLocaleTimeString(this.$i18n.locale, { hour: 'numeric', minute: '2-digit' });
      if (!end) return startStr;
      const endStr = end.toLocaleTimeString(this.$i18n.locale, { hour: 'numeric', minute: '2-digit' });
      return `${startStr} - ${endStr}`;
    },
    getProfessorName(event) {
      const p = event.professor;
      return p?.displayName || '';
    },
    getParticipantsText(event) {
      return event.startNumber ? `+ ${Number.parseInt(event.startNumber)} more` : "";
      // const count = event.participantCount ?? event.registeredCount ?? event.extendedProps?.participantCount;
      // const first = event.firstParticipantName ?? event.extendedProps?.firstParticipantName;
      // if (count > 0 && first) return `${first} + ${count - 1} more`;
      // if (count > 0) return `${count} ${this.$t('message.participants')}`;
      // return null;
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-list-events {
  padding: 0;
}

.custom-list-event-row-mobile {
  align-items: stretch;
  gap: 16px;
  cursor: pointer;
  transition: background-color 0.15s;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.custom-list-event-indicator-mobile {
  width: 14px;
  height: 14px;
  min-width: 4px;
  flex-shrink: 0;
}

.custom-list-event-content {
  flex: 1;
  display: flex;
  gap: 24px;
  min-width: 0;
}

.custom-list-event-col--primary {
  flex: 1.2;
}

.custom-list-event-col--secondary,
.custom-list-event-col--tertiary {
  flex: 1;
}

.custom-list-event-title {
  font-size: 15px;
  line-height: 1.3;
  color: #1E88E5;
}


.custom-list-event-divider {
  width: 1px;
  min-width: 1px;
  background: #E0E0E0;
  align-self: stretch;
}

/* Dark mode */
.custom-list-events--dark .custom-list-event-title {
  color: #90CAF9;
}

.custom-list-events--dark .custom-list-event-meta {
  color: rgba(255, 255, 255, 0.7);
}

.custom-list-events--dark .custom-list-event-divider {
  background: rgba(255, 255, 255, 0.12);
}

@media (max-width: 960px) {
  .custom-list-event-content {
    flex-wrap: wrap;
  }

  .custom-list-event-divider {
    display: none;
  }

  .custom-list-event-col {
    flex: 1 1 100%;
  }
}
</style>
